PJQ.views.primeContracts.PrimeContractsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'prime-contracts-list'),
        primeContractId: null
    },
    events: {
        'click .btn-pull-erp': 'pullERP',
        'click .btn-settings': 'editSettings',
        'click .btn-add-prime-contract': 'addPrimeContractClicked',
        'click .btn-delete-prime-contract': 'deletePrimeContractClicked',
        'click .btn-view-prime-contract': 'viewPrimeContractClicked',
        'click .btn-add-change-order': 'addChangeOrderClicked',
        'click .btn-export': 'exportPrimeContractList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.primeContracts.PrimeContracts(null, {
                projectId: PJQ.app.session.project.id,
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.userSettings = await PJQ.app.session.fetchPrimeContractUserSettings();
        this.customFields = await this.options.project.fetchPrimeContractCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.hasPermission('primeContracts.canEdit');
        this.options.isAdmin = this.options.project.hasPermission('primeContracts.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        if (this.options.primeContractId > 0) {
            let initContract = this.collection.get(this.options.primeContractId);
            if (initContract != null) {
                this.viewPrimeContract(initContract);
                this.options.primeContractId = null;
            }
        }
    },
    renderERPButton: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS) || !this.options.project || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PRIME_CONTRACTS);
        this.erpButtons = PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: false,
            pullSupported: pullSupported
        });
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PRIME_CONTRACTS)) {
            this.erpButtons?.pulling(true);
            this.erpIntegration.pullPrimeContracts(this.options.project, _.bind(function (res) {
                this.erpButtons?.pulling(false);
                this.collection.reset(res);
                PJQ.notifications.notify.successNotify({
                    message: 'Contracts pulled from ERP'
                });
                this.render();
            }, this));
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.primeContracts.PrimeContractDataTable({
            el: this.$('.prime-contracts-data'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    canAdd: this.options.canEdit,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.primeContracts.view.PRIME_CONTRACTS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewPrimeContract(row.data());
            }, this),
            afterDataTableRender: _.bind(function () {
                this.renderERPButton();
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewPrimeContract(row.data());
                        }, this)
                    },
                    {
                        name: 'New Change Order',
                        onClick: _.bind(function (row) {
                            this.addChangeOrder(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            let status = row.data().get('statusId');
                            return status === (PJQ.constants.primeContracts.primeContractStatus.APPROVED || PJQ.constants.primeContracts.primeContractStatus.COMPLETE) && this.options.project.hasPermission('primeContractChangeOrders.canAdd');
                        }, this),
                    },
                    {
                        name: 'New Change Request',
                        onClick: _.bind(function (row) {
                            this.addChangeRequest(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            let status = row.data().get('statusId');
                            return status === (PJQ.constants.primeContracts.primeContractStatus.APPROVED || PJQ.constants.primeContracts.primeContractStatus.COMPLETE) && this.options.project.hasPermission('changeRequests.canAdd');
                        }, this),
                    },
                ]
            }
        });
    },
    addPrimeContractClicked: function () {
        this.viewPrimeContract();
    },
    exportPrimeContractList: function () {
        let parameters = [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ];

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'primecontracts'
            },
            {
                endpoint: 'export'
            }
        ], parameters), {isAPIv2: true});
    },
    editSettings: function () {
        new PJQ.views.primeContracts.PrimeContractSettingsModal({
            primeContractView: this,
            onSave: _.bind(function () {
                this.render();
            }, this)
        });
    },
    addChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow((e.currentTarget).closest('tr'));
        this.addChangeOrder(row.data());
    },
    addChangeOrder: function (primeContract) {
        new PJQ.views.primeContracts.ChangeOrderEditModal({
            primeContract: primeContract,
            onSave: _.bind(function (changeOrder) {
                primeContract.changeOrders.add(changeOrder);

                if (typeof this.options.onChangeOrderAdd === 'function') {
                    this.options.onChangeOrderAdd(changeOrder);
                }
            }, this)
        });
    },
    addChangeRequest: function (primeContract) {
        new PJQ.views.changeRequests.ChangeRequestEditModal({
            primeContract: primeContract,
            onSave: _.bind(function (changeRequest) {
                primeContract.changeRequests.add(changeRequest);

                if (typeof this.options.onChangeRequestAdd === 'function') {
                    this.options.onChangeRequestAdd(changeRequest);
                }
            }, this)
        });
    },
    viewPrimeContractClicked: function (e) {
        let row = this.dataTable.getRow((e.currentTarget).closest('tr'));
        this.viewPrimeContract(row.data());
    },
    viewPrimeContract: function (contract) {
        let isNew = contract == null;
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: contract,
            onChangeOrderAdd: _.bind(function (changeOrder) {
                if (typeof this.options.onChangeOrderAdd === 'function') {
                    this.options.onChangeOrderAdd(changeOrder);
                }
            }, this),
            onChangeOrderDelete: _.bind(function (changeOrderId) {
                if (typeof this.options.onChangeOrderDelete === 'function') {
                    this.options.onChangeOrderDelete(changeOrderId);
                }
            }, this),
            onSave: _.bind(function (model) {
                if (isNew) {
                    this.collection.add(model);
                    this.dataTable.addRow(model);
                } else {
                    this.dataTable.refresh();
                }
                if (typeof this.options.onChange === 'function') {
                    this.options.onChange();
                }
            }, this)
        })
    },
    deletePrimeContractClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deletePrimeContract(row);
    },
    deletePrimeContract: function (row) {
        if (row != null) {
            let primeContract = row.data();
            if (primeContract != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Contract",
                    body: "Are you sure you want to delete this Contract?",
                    onDelete: _.bind(function () {
                        primeContract.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(primeContract);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    }
});

PJQ.views.primeContracts.ModalViewPrimeContracts = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-view-prime-contracts'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.primeContracts.PrimeContractsList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                project: this.options.project
            })
        }
    },
});

PJQ.views.primeContracts.SelectPrimeContractsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-select-prime-contracts'),
        width: '50%',
        maxWidth: 700,
        onSave: _.noop,
        headerSubText: null
    },
    events: {
        "change .select-prime-contract": "selectPrimeContract",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.project.hasPermission('primeContracts.isAdmin');

        if (this.collection == null) {
            this.collection = new PJQ.collections.primeContracts.PrimeContracts(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (this.collection.isFetched) {
            this.render();
        } else {
            this.collection.fetch({
                success: _.bind(function () {
                    this.primeContracts = this.collection.models;

                    if (this.options.filterStatuses) {
                        this.primeContracts = _.filter(this.primeContracts, function (model) {
                            let statusId = model.get('statusId');

                            if (_.isArray(this.options.filterStatuses)) {
                                return _.includes(this.options.filterStatuses, statusId);
                            } else if (_.isNumber(this.options.filterStatuses)) {
                                return this.options.filterStatuses === statusId;
                            }

                            return false;

                        }, this);
                    }
                    this.render();
                }, this)
            });
        }

    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        if (_.size(this.collection.models) === 1) {
            let selPc = this.collection.models[0];
            selPc.set('isSelected', true);
            this.selectedPrimeContract = selPc;
        }

        this.$('.btn-save').attr('disabled', this.selectedPrimeContract == null);

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.prime-contracts-table'),
            data: this.primeContracts,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-prime-contract"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectPrimeContract: function (e) {
        let target = $(e.currentTarget),
            primeContract = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-prime-contract').not(target).text('Select').prop('checked', false);
            if (primeContract.get('isSelected')) {
                primeContract.set('isSelected', false);
                this.selectedPrimeContract = null;
            } else {
                primeContract.set('isSelected', true);
                this.selectedPrimeContract = primeContract;
                this.collection.get(primeContract.id);
                _.each(this.collection.models, _.bind(function (dtPrimeContract) {
                    if (primeContract.id !== dtPrimeContract.id)
                        dtPrimeContract.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedPrimeContract == null);

            if (typeof this.options.onPrimeContractSelected === 'function') {
                this.options.onPrimeContractSelected(this.selectedPrimeContract);
            }
        } else {
            if (primeContract.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                primeContract.set('isSelected', false);
                this.selectedPrimeContracts = _.reject(this.selectedPrimeContracts, function (selPrimeContract) {
                    return selPrimeContract.id === primeContract.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                primeContract.set('isSelected', true);
                this.selectedPrimeContracts.push(primeContract);
            }
            this.$('.btn-save').attr('disabled', this.selectedPrimeContracts == null);

            if (typeof this.options.onPrimeContractSelected === 'function') {
                this.options.onPrimeContractSelected(this.selectedPrimeContracts);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.removeModal();
            this.options.onSave(this.selectedPrimeContract ? this.selectedPrimeContract : this.selectedPrimeContracts);
        }
    }
});